export type EyeDropperInstance = {
  open: (options?: { signal?: AbortSignal }) => Promise<{ sRGBHex: string }>
}

export type EyeDropperConstructor = new () => EyeDropperInstance

type WindowWithEyeDropper = Window & {
  EyeDropper?: EyeDropperConstructor
}

export function isScreenColorPickSupported(): boolean {
  return typeof window !== 'undefined' && typeof (window as WindowWithEyeDropper).EyeDropper === 'function'
}

/** Normalizes EyeDropper `sRGBHex` to `#RRGGBB` uppercase. */
export function normalizeScreenPickedHex(sRGBHex: string): string | null {
  const trimmed = sRGBHex.trim()
  if (!/^#[0-9a-f]{6}$/i.test(trimmed)) {
    return null
  }
  return `#${trimmed.slice(1).toUpperCase()}`
}

export async function pickColorFromScreen(): Promise<string | null> {
  if (!isScreenColorPickSupported()) {
    return null
  }
  const EyeDropper = (window as WindowWithEyeDropper).EyeDropper as EyeDropperConstructor
  const dropper = new EyeDropper()
  const { sRGBHex } = await dropper.open()
  return normalizeScreenPickedHex(sRGBHex)
}
